import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, emitirTrocaVoluntariaPlaca } from './types';

export const INITIAL_STATE: emitirTrocaVoluntariaPlaca = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): emitirTrocaVoluntariaPlaca {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMITIR_TROCA_VOLUNTARIA_PLACA_REQUEST: {
				break;
			}

			case Types.EMITIR_TROCA_VOLUNTARIA_PLACA_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.EMITIR_TROCA_VOLUNTARIA_PLACA_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.EMITIR_TROCA_VOLUNTARIA_PLACA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
